export default __webpack_public_path__ + "static/media/1987.fdffbf8a.png";